import React from 'react';

import { useDealerLayer } from './hooks/useDealerLayer';
import { createBridgeLayerRender } from '../../../shared/utils/create-bridge-layer-render';
import { ManageDealerLayerContentView, ManageDealerLayerViewProps } from '../components/ManageDealerLayerContent/ManageDealerLayerContentView';

interface ManageDealerLayersProps {
  dealerLayerActive: boolean;
  onClose: () => void;
}

const dealerLayerRender = createBridgeLayerRender<ManageDealerLayerViewProps>(
  (data) => data.translationHandler(data.titleKey),
  (data) => <ManageDealerLayerContentView {...data} />,
);

export const useManageDealerLayers = ({ dealerLayerActive, onClose }: ManageDealerLayersProps) => {
  useDealerLayer(dealerLayerActive, onClose, dealerLayerRender);
};
